export default __webpack_public_path__ + "static/media/smalandia_szwecja.8ad945a8.jpg";